(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["image"] && !Shopify.designMode) return;
  try {
    requestAnimationFrame(() => {
    document.querySelectorAll('.image-block__hover-text').forEach(el => {
      el.style.minWidth = '';
      const h = el.scrollHeight;
      const w = Math.ceil(h * 4 / 3);
      if (el.offsetWidth < w) {
        el.style.minWidth = w + 'px';
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
